import styled from 'styled-components';
import { Box, Text, Button } from '@rsos/components/capstone/base';

export const PastButton = styled(Button).attrs({
  px: 0,
  btnType: 'tertiary',
})`
  margin: 0;
  height: 30px;
`;

export const ViewText = styled(Text).attrs({
  size: 'small',
  ml: 2,
  color: 'primaryText',
})``;

export const HeadlineText = styled(Text).attrs({
  pl: '3px',
  size: 'normal',
  fontWeight: 'bold',
  color: 'primaryText',
})`
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ContainerBox = styled(Box).attrs({
  width: '270px',
  position: 'absolute',
  overflow: 'auto',
})`
  top: 35px;
  right: 0;
  max-height: 360px; //for when there's more than one option
  z-index: 1;
  border-radius: 5px;
  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 13%); //spec from design team
`;

export const HeadlineContainer = styled(Box).attrs({
  align: 'center',
  justify: 'space-between',
  px: '10px',
  py: '10px',
  bg: 'background',
})`
  border-radius: 5px 5px 0 0;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};

  border-bottom: none;
`;

export const Resizer = styled.div`
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 5px 5px;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.secondaryLink};
  border-top: none;
`;

export const HistoricLocationsToggleWrapper = styled(Box).attrs({
  position: 'relative',
  align: 'flex-end',
  width: '320px',
})``;
